module.exports = __webpack_public_path__ + "be17849c037be7b9b3bce9fa36bb99cf.svg";